import React from "react";

import { Container, Row } from "reactstrap";
import MaterialStyleTab from "../../../Components/settings/Countries/TabCountries";

const CountriesFlag = () => {
  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <MaterialStyleTab/>
        </Row>
      </Container>
    </div>
  );
};

export default CountriesFlag;
